import _ from "lodash"

export default function initialValues(data) {
  const fieldsPerBlock = (block) => {
    return _.reduce(
      block.fields,
      (acc, field) => {
        if (field.field_type === "checkbox") {
          return {
            ...acc,
            [field.field_name]: [],
          }
        }
        if (
          field.field_type === "number" ||
          field.field_type === "conditional_number"
        ) {
          return {
            ...acc,
            [field.field_name]: null,
          }
        }
        if (field.field_type === "multi_field") {
          return {
            ...acc,
            [field.field_name]: [],
          }
        }
        if (
          field.field_type === "dropdown" ||
          field.field_type === "conditional_dropdown"
        ) {
          return {
            ...acc,
            [field.field_name]: field.field_default_value || "",
          }
        }
        return {
          ...acc,
          [field.field_name]: "",
        }
      },
      {}
    )
  }

  return _.reduce(
    data.template.blocks,
    (acc, block) => {
      const fields = fieldsPerBlock(block)
      return {
        ...acc,
        ...fields,
      }
    },
    {}
  )
}
